import React, { createContext, useContext, useRef } from 'react';
var ChartContext = /*#__PURE__*/createContext(null);
export function ChartProvider(_ref) {
  var children = _ref.children;
  var chartRef = useRef(null);
  return /*#__PURE__*/React.createElement(ChartContext.Provider, {
    value: chartRef
  }, children);
}
export function useChart() {
  var context = useContext(ChartContext);
  if (!context) {
    throw new Error('`useChart` can only be used inside `<ChartProvider/>`');
  }
  return context;
}